export default "__VITE_ASSET__dc5356c3__"